
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.537 17.567A9.962 9.962 0 0110 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10c0 2.136-.67 4.116-1.81 5.74L15 10h3a8 8 0 10-2.46 5.772l.997 1.795z","fill":"#FAAD14"}})])
          )
        }
      }
    